import { BehaviorSubject, Observable } from 'rxjs';

import { AlertMessage, ClickAction, ExternalLink } from '@cart-checkout/checkout/data-access/interfaces';
/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { SinglePageCards } from '@cart-checkout/checkout/data-access/enums';

@Injectable({
	providedIn: 'root'
})
export class ErrorMessageFeedService {
	private _feed: BehaviorSubject<AlertMessage[]> = new BehaviorSubject([]);

	public feed: Observable<AlertMessage[]> = this._feed.asObservable();

	public push(message: string, clickAction?: ClickAction, externalLink?: ExternalLink, messageLocation?: SinglePageCards) {
		if (this._feed.value.find((existingMessage) => { return existingMessage.message === message; }) === undefined) {
			this._feed.next([...this._feed.value, new AlertMessage(message, clickAction, externalLink, messageLocation)]);
		}
	}
	public remove(message: string) {
		this._feed.next([...this._feed.value.filter((existingMessage) => { return existingMessage.message !== message; })]);
	}

	public clear() {
		this._feed.next([]);
	}
}
